<div class="d-flex align-items-center justify-content-between px-4 pt-4 px-md-8 pt-md-8">
  <h2 class="semi-bold">This fare comes with limitations</h2>

  <ds-button
    (click)="hideModal.emit()"
    variant="icon"
    size="s"
    icon="xmark"
    label="Close"
    class="d-none d-md-inline"
    data-id="hide"
  />
</div>

<div class="mt-6 mx-4 mx-md-8 table">
  <p></p>
  <p></p>

  <p class="semi-bold text-align-center">Basic</p>
  <p class="semi-bold text-align-center">Essential</p>

  @for (feature of features; track feature) {
    <img
      [alt]="feature.image"
      src="/assets/images/{{ feature.image }}.webp"
      width="40"
      height="40"
    />

    <p>{{ feature.label }}</p>

    <p
      [ngClass]="{
        'text-jazlyn-700': feature.values.basic === ValueEnum.False,
        'text-green-750': feature.values.basic === ValueEnum.True,
      }"
      class="text-align-center"
    >
      {{ feature.values.basic }}
    </p>

    <p
      [ngClass]="{
        'text-jazlyn-700': feature.values.essential === ValueEnum.False,
        'text-green-750': feature.values.essential === ValueEnum.True,
      }"
      class="text-align-center"
    >
      {{ feature.values.essential }}
    </p>
  }
</div>

<div class="mt-6 mx-4 mx-md-8">
  <a (click)="review.emit()" class="link">
    <p class="text-lightblue-800">View all Essential benefits</p>
  </a>
</div>

<div class="d-flex flex-column mx-4 mx-md-8 mb-4 mb-md-8 mt-6">
  <ds-button
    (click)="upgrade.emit()"
    [label]="'Upgrade to Essential +' + (upgradePricePerPassenger | portalCurrency) + '/passenger'"
    [fullWidth]="true"
    data-id="upgrade"
  />

  <ds-button
    (click)="continue.emit()"
    variant="secondary"
    label="Continue with Basic"
    [fullWidth]="true"
    class="mt-3"
    data-id="continue"
  />
</div>
